var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-logic-container" },
    [
      _c("el-scrollbar", { staticClass: "scrollbar-container" }, [
        _c("p", { staticClass: "logic_title ml-100" }, [_vm._v("逻辑设置")]),
        _c(
          "p",
          { staticClass: "text-desc ml-100" },
          [
            _vm._v(" 仅在符合以下条件时"),
            _c(
              "el-tooltip",
              {
                staticClass: "item",
                attrs: {
                  content:
                    "你可以使用某些题型（单选题、多选题、图片选择、评分组件、NPS组件、下拉选择）或外部参数设定一些条件",
                  effect: "dark",
                  placement: "top",
                },
              },
              [_c("i", { staticClass: "el-icon-question" })]
            ),
            _vm._v(
              "，显示相应题目。运算优先级：并且>或者，示例：条件1 并且 条件2 或者 条件3 并且 条件4 =（ 条件1 并且 条件2）或者（ 条件3 并且 条件4 ） "
            ),
          ],
          1
        ),
        _c("div", { staticClass: "show-logic-container" }, [
          !_vm.logicList.length
            ? _c(
                "div",
                { staticClass: "not-logic-container" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { offset: 10, span: 5 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.addLogicHandle },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-circle-plus-outline",
                              }),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("添加逻辑"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "logic-list-container" },
                [
                  _c(
                    "el-row",
                    {
                      attrs: {
                        align: "middle",
                        justify: "center",
                        type: "flex",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { offset: 4, span: 10 } },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "message-tag",
                              attrs: { effect: "plain", type: _vm.isSave },
                            },
                            [_vm._v(_vm._s(_vm.saveMessage))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { offset: 6, span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                icon: "el-icon-plus",
                                loading: _vm.isLoading,
                                type: "primary",
                              },
                              on: { click: _vm.addLogicHandle },
                            },
                            [
                              _c("i", {}),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("添加逻辑"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-row divider_box" },
                    [
                      _c("div", { staticStyle: { width: "100px" } }),
                      _c("el-divider", { staticStyle: { flex: "1" } }),
                    ],
                    1
                  ),
                  _vm._l(_vm.logicList, function (logicItem, index) {
                    return _c(
                      "div",
                      { key: logicItem.id, staticClass: "logic-list" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "logic-list-delete",
                            on: {
                              click: function ($event) {
                                return _vm.handleRemoveLogicItem(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-delete" })]
                        ),
                        _vm._l(
                          logicItem.conditionGroup,
                          function (logicgroup, gIndex) {
                            return _c(
                              "div",
                              {
                                key: logicItem.id + "group" + gIndex,
                                staticClass: "logic-list-group",
                              },
                              [
                                [
                                  gIndex === 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "logic-list-group-relation",
                                        },
                                        [_vm._v("如果:")]
                                      )
                                    : _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "90px" },
                                          model: {
                                            value: logicgroup.relation,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                logicgroup,
                                                "relation",
                                                $$v
                                              )
                                            },
                                            expression: "logicgroup.relation",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "并且",
                                              value: "AND",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "或者",
                                              value: "OR",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                _c(
                                  "div",
                                  { staticClass: "logic-list-group-condition" },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          placement: "bottom-end",
                                          width: "50",
                                          "popper-class": "btns_more_popover",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btns_more_item fs12",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delLogicGroup(
                                                  logicItem,
                                                  index,
                                                  gIndex
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btns_more",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-more",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      logicgroup.conditionList,
                                      function (cItem, cIndex) {
                                        return _c(
                                          "el-row",
                                          {
                                            key: cIndex,
                                            staticClass:
                                              "mt5 condition-content",
                                            attrs: {
                                              gutter: 20,
                                              align: "middle",
                                              justify: "center",
                                              type: "flex",
                                            },
                                          },
                                          [
                                            cIndex !== 0
                                              ? _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { span: 3 },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        model: {
                                                          value: cItem.relation,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              cItem,
                                                              "relation",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "cItem.relation",
                                                        },
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "并且",
                                                            value: "AND",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "或者",
                                                            value: "OR",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleClearExpression(
                                                          cItem
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: cItem.type,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cItem,
                                                          "type",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "cItem.type",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "题目",
                                                        value: "_TITLE",
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "外部参数",
                                                        value: "_PARAMETERS",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 9 } },
                                              [
                                                cItem.type === "_PARAMETERS"
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "请选择参数",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleParameterChange(
                                                              cItem
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            cItem.parameter,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              cItem,
                                                              "parameter",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "cItem.parameter",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.parameterChildList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.value,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _c("el-cascader", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        options:
                                                          _vm.getConditionProjectItemList(
                                                            logicItem
                                                          ),
                                                        filterable: true,
                                                        "show-all-levels": false,
                                                        "append-to-body": false,
                                                        placeholder:
                                                          "请选择题目",
                                                        props: {
                                                          expandTrigger:
                                                            "hover",
                                                          emitPath: false,
                                                        },
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleConditionChange(
                                                            cItem,
                                                            logicItem
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: cItem.formItemId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            cItem,
                                                            "formItemId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "cItem.formItemId",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择",
                                                    },
                                                    model: {
                                                      value: cItem.expression,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cItem,
                                                          "expression",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cItem.expression",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.getConditionOptions(
                                                      cItem
                                                    ),
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                cItem.type == "_TITLE"
                                                  ? [
                                                      !["RATE", "NPS"].includes(
                                                        _vm.getFormItemIdType(
                                                          cItem.formItemId
                                                        )
                                                      )
                                                        ? _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  "请选择选项",
                                                              },
                                                              model: {
                                                                value:
                                                                  cItem.optionValue,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      cItem,
                                                                      "optionValue",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "cItem.optionValue",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getFormItemOptions(
                                                                cItem.formItemId
                                                              ),
                                                              function (item) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: item.value,
                                                                    attrs: {
                                                                      label:
                                                                        item.label,
                                                                      value:
                                                                        item.value,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _c(
                                                            "el-input-number",
                                                            {
                                                              attrs: { min: 0 },
                                                              model: {
                                                                value:
                                                                  cItem.optionValue,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      cItem,
                                                                      "optionValue",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "cItem.optionValue",
                                                              },
                                                            }
                                                          ),
                                                    ]
                                                  : _vm._e(),
                                                cItem.type === "_PARAMETERS"
                                                  ? [
                                                      _vm.getCurParameter(
                                                        cItem.parameter
                                                      ).eleType === "input"
                                                        ? _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                _vm.getCurParameter(
                                                                  cItem.parameter
                                                                )
                                                                  .placeholderText,
                                                            },
                                                            model: {
                                                              value:
                                                                cItem.parameterValue,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    cItem,
                                                                    "parameterValue",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "cItem.parameterValue",
                                                            },
                                                          })
                                                        : _c(
                                                            "el-select",
                                                            {
                                                              attrs: {
                                                                filterable: "",
                                                                placeholder:
                                                                  _vm.getCurParameter(
                                                                    cItem.parameter
                                                                  )
                                                                    .placeholderText,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    val
                                                                  ) {
                                                                    return _vm.parValueChange(
                                                                      val,
                                                                      cItem
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  cItem.parameterSelectValue,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      cItem,
                                                                      "parameterSelectValue",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "cItem.parameterSelectValue",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getCurParameter(
                                                                cItem.parameter
                                                              ).options,
                                                              function (item) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: item.value,
                                                                    attrs: {
                                                                      label:
                                                                        item.label,
                                                                      value:
                                                                        item.value,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "el-col",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: { span: 4 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "btns" },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: { type: "text" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.addConditionHandle(
                                                              logicgroup,
                                                              cItem,
                                                              cIndex
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-plus-outline",
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass: "remove",
                                                        attrs: { type: "text" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeConditionHandle(
                                                              logicItem,
                                                              gIndex,
                                                              cIndex,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-remove-outline",
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "logic-list-group-add",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addConditionGroup(
                                          logicItem,
                                          gIndex
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-folder-add",
                                    }),
                                    _vm._v(" 添加条件组 "),
                                  ]
                                ),
                              ],
                              2
                            )
                          }
                        ),
                        _vm._l(
                          logicItem.triggerList,
                          function (trigger, tindex) {
                            return _c(
                              "el-row",
                              {
                                key: "t1" + tindex,
                                staticClass: "logic-list-trigger",
                                attrs: { align: "middle", type: "flex" },
                              },
                              [
                                _c("span", { staticClass: "mr-10" }, [
                                  _vm._v("则显示"),
                                ]),
                                _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        options:
                                          _vm.getTriggerItemList(logicItem),
                                        filterable: true,
                                        "show-all-levels": false,
                                        "append-to-body": false,
                                        placeholder: "请选择问题",
                                        props: {
                                          expandTrigger: "hover",
                                          emitPath: false,
                                        },
                                      },
                                      model: {
                                        value: trigger.formItemId,
                                        callback: function ($$v) {
                                          _vm.$set(trigger, "formItemId", $$v)
                                        },
                                        expression: "trigger.formItemId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "text-center",
                                    attrs: { span: 3 },
                                  },
                                  [_c("span", [_vm._v("否则不显示")])]
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addTriggerItemHandle(
                                              logicItem
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus-outline",
                                        }),
                                      ]
                                    ),
                                    logicItem.triggerList.length > 1
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "remove",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeTriggerItemHandle(
                                                  logicItem,
                                                  index,
                                                  tindex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-remove-outline",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-row divider_box" },
                          [
                            _c("div", { staticStyle: { width: "100px" } }),
                            _c("el-divider", { staticStyle: { flex: "1" } }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }